// extracted by mini-css-extract-plugin
export default {"device-item-card":"device-item-card_device-item-card__3aRDo"};